import inegiPxWeb from '../api/inegi-pxweb';
import _ from 'lodash';
import { setStubHeadingFromColumn } from './pivot';

export const fetchMetaData = () => async (dispatch, getState) => {
    const { lang, file } = getState().selection;
    const idt = getState().config.idt;
    const response = await inegiPxWeb.get('/tabulado', {
        params: { lang, file, idt }
    });

    dispatch({ type: 'FETCH_METADATA', payload: response.data })
    //se crea una copia para manipular los aggs en la grafica
    dispatch({ type: 'FETCH_METADATA_CHART', payload: response.data })
}

export const fetchInfo = () => async (dispatch, getState) => {
    const mmm = getState().selection;
    const idt = getState().config.idt;
    const response = await inegiPxWeb.post('/info', mmm, { params: { idt } });
    dispatch({ type: 'FETCH_INFO', payload: response.data })
}

export const fetchInfoDescription = () => async (dispatch, getState) => {
    const mmm = getState().selection;
    const idt = getState().config.idt;
    const response = await inegiPxWeb.post('/info', mmm, { params: { idt } });
    dispatch({ type: 'FETCH_INFO_DESCRIPTION', payload: response.data.description })
}

export const fetchData = () => async (dispatch, getState) => {
    const { stub, heading } = getState().column;
    dispatch(setStubHeadingFromColumn(stub, heading));
    const mmm = getState().selection;
    const idt = getState().config.idt;
    const response = await inegiPxWeb.post('/datatable', mmm, { params: { idt } });
    dispatch({ type: 'FETCH_DATA', payload: response.data })
}

export const fetchDataChartLine = (ind, area) => async (dispatch, getState) => {

    const { stub, heading } = getState().column;
    const mmm = getState().selection;

    const filterMetadata = getState().metaChart.variables;
    const querySelect = getState().selectionChartLine.query;
    const newQuerySelectChart = _.cloneDeep(querySelect);
    const copymmm = _.cloneDeep(mmm);
    let newarrayvalues = [];
    //actualización del tipo de filtro y valores en el Selection para hacer la consulta a la api 
    newQuerySelectChart.query = newQuerySelectChart.query.map(item => {
        newarrayvalues = [];
        let query = {
            code: item.code,
            selection: {}
        }
        if (item.code == area) {
            const { domain, values, aggs } = filterMetadata.find(f => f.code === area);
            if (item.selection.values.length == 1 && item.selection.values.indexOf('*') != -1) {
                newarrayvalues = _.isNull(domain) ? values.filter((item, index) => index === 0) : aggs[0].values.filter((item, index) => index === 0);
                query.selection = { filter: 'item', values: newarrayvalues };
            }
            else if (item.selection.values.length > 1) {
                newarrayvalues.push(item.selection.values[0]);
                query.selection = { filter: 'item', values: newarrayvalues };
            }
            else
                query.selection = { filter: 'item', values: item.selection.values };
            return query;
        }
        return item;
    });

    let arrayCode = [];
    arrayCode = copymmm.query.query.map(q => {
        let query = {};
        if (q.code !== ind && q.code !== area) {
            query = {
                code: q.code,
                selection: {
                    filter: 'all',
                    values: ['*']
                }
            }
            return query;
        }
        else if (q.code == ind || q.code == area) {
            return newQuerySelectChart.query.find(item => item.code === q.code);
        }
    });
    copymmm.query.query = arrayCode;


    const { code, selection } = copymmm.query.query.find((q) => {
        if (q.code == area) {
            return q;
        }
    })
    let query = {
        code: code,
        values: selection.values
    }
    dispatch({ type: 'SET_STATUS_CHECK_CHART_LINE', payload: query });
    //Pivoteo de stub y heading; 
    const idt = getState().config.idt;
    copymmm.stub = [...getState().metadata.stub, ...getState().metadata.heading];
    copymmm.heading = [];
    const response = await inegiPxWeb.post('/datatable', copymmm, { params: { idt } });
    dispatch({ type: 'FETCH_DATA_CHART_LINE', payload: response.data })
}

export const fetchDataChartIps = (ind, area) => async (dispatch, getState) => {

    const { stub, heading } = getState().column;
    const mmm = getState().selection;
    const tabIps = getState().infoDescription;
    const filterMetadata = getState().metaChart.variables;
    const queryRadioSelect = getState().radio.query;
    const newQuerySelectChart = _.cloneDeep(queryRadioSelect);
    const copymmm = _.cloneDeep(mmm);
    let newarrayvalues = [];
    //Reestructuración de la Selection para hacer la consulta a la api
    newQuerySelectChart.query = newQuerySelectChart.query.map(item => {
        newarrayvalues = [];
        let query = {
            code: item.code,
            selection: {}
        }
        if (item.code == ind || item.code == area) {
            const { domain, values, aggs } = filterMetadata.find(f => f.code === item.code);
            if (item.selection.values.length == 1 && item.selection.values.indexOf('*') != -1) {
                newarrayvalues = _.isNull(domain) ? values.filter((item, index) => index === 0) : aggs[0].values.filter((item, index) => index === 0);
                query.selection = { filter: 'item', values: newarrayvalues };
            }
            else if (item.selection.values.length > 1) {
                newarrayvalues.push(item.selection.values[0]);
                query.selection = { filter: 'item', values: newarrayvalues };
            }
            else
                query.selection = { filter: 'item', values: item.selection.values };
            return query;
        }
        return item;
    });

    let arrayCode = [];
    let isIps = tabIps != "";
    if (isIps) {
        arrayCode = copymmm.query.query.map(q => {
            let query = {};
            if (q.code !== ind && q.code !== area) {
                query = {
                    code: q.code,
                    selection: {
                        filter: 'all',
                        values: ['*']
                    }
                }
                return query;
            }
            else if (q.code == ind || q.code == area) {
                return newQuerySelectChart.query.find(item => item.code === q.code);
            }
        });
        copymmm.query.query = arrayCode;
        let { code, selection } = copymmm.query.query.find((q) => {
            if (q.code == area) {
                return q;
            }
        })
        let query = {
            code: code,
            values: selection.values
        }
        dispatch({ type: 'SET_STATUS_CHECK_RADIO', payload: query });
        const queryInd = copymmm.query.query.find((q) => {
            if (q.code == ind) {
                return q;
            }
        })
        query = {
            code: queryInd.code,
            values: queryInd.selection.values
        }
        dispatch({ type: 'SET_STATUS_CHECK_RADIO', payload: query });
        //Pivoteo de stub y heading; 
        const newStubHeading = _.cloneDeep(mmm);
        const idt = getState().config.idt;
        copymmm.stub = [...getState().metadata.stub, ...getState().metadata.heading];
        copymmm.heading = [];
        const response = await inegiPxWeb.post('/datatable', copymmm, { params: { idt } });

        dispatch({ type: 'FETCH_DATA_CHART', payload: response.data })
    }

}
const setValueInitQuery = ((filter, objQuery, dispatch) => {
    const queryInd = objQuery.query.query.find((q) => {
        if (q.code == filter) {
            return q;
        }
    })
    let query = {
        code: queryInd.code,
        values: queryInd.selection.values
    }

    dispatch({ type: 'SET_STATUS_CHECK_RADIO', payload: query });

});

export const getPXQ = (checkHideRow) => async (dispatch, getState) => {
    const mmm = getState().selection;
    let copymmmm = _.cloneDeep(mmm);
    copymmmm.hiderows = checkHideRow;
    const idt = getState().config.idt;
    const response = await inegiPxWeb.post('/tabquery', copymmmm, { params: { idt } });
    dispatch({ type: 'GET_PXQ', payload: response.data.pxq })
}
export const getTopPXQ = (top, checkHideRow) => async (dispatch, getState) => {
    const mmm = getState().selection;
    let copymmmm = _.cloneDeep(mmm);
    copymmmm.hiderows = checkHideRow;
    const varTime = getState().config.varTime;
    const newSelection = _.cloneDeep(copymmmm);
    const query = {
        code: varTime,
        selection: {
            filter: 'top',
            values: [top]
        }
    }
    newSelection.query.query = newSelection.query.query.map(q => (q.code === varTime ? query : q));
    const idt = getState().config.idt;
    const response = await inegiPxWeb.post('/tabquery', newSelection, { params: { idt } });
    dispatch({ type: 'GET_PXQ', payload: response.data.pxq })
}

export const fetchPXQ = (pxq) => async (dispatch, getState) => {
    const idt = getState().config.idt;
    const response = await inegiPxWeb.get('/tabquery', {
        params: { pxq, idt }
    });
    dispatch({ type: 'FETCH_PXQ', payload: response.data })
}